import React, { useEffect } from 'react';
import { get } from 'lodash';
import { SdfBusyIndicator, SdfExpandableBox } from '@synerg/react-components';
import { useApplicationState } from '../../../utilities/applicationState';

export default function ScopesConsentDetails({ projectDetails, setDefaults, selectedEnvironment, projectCarDetails, show }) {
	const [store] = useApplicationState();
	const { loadings } = store;
	const { isLoadingCarDetails = true } = loadings;

	let b2cScopes, b2bScopes, b2bConsents, b2cConsents;

	if (selectedEnvironment === 'PROD') {
		b2cScopes = get(projectCarDetails, 'prod.b2cScopes', []);
		b2bScopes = get(projectCarDetails, 'prod.b2bScopes', []);
		b2bConsents = get(projectCarDetails, 'prod.b2bConsents', []);
		b2cConsents = get(projectCarDetails, 'prod.b2cConsents', []);
	} else {
		b2cScopes = get(projectCarDetails, 'b2cListOfScopes', []);
		b2bScopes = get(projectCarDetails, 'b2bListOfScopes', []);
		b2bConsents = get(projectCarDetails, 'b2bConsentTexts', []);
		b2cConsents = get(projectCarDetails, 'b2cConsentTexts', []);
	}

	const isEndUserApp = b2cScopes.length > 0 || b2cConsents.length > 0;
	const isDataConnectorApp = b2bScopes.length > 0 || b2bConsents.length > 0;

	useEffect(() => {
		const hasProdData = get(projectDetails, 'legacy', false) && get(projectDetails, 'type', '') === 'PROD'
			? get(projectDetails, '_id', '')
			: get(projectDetails, 'associatedProject._id', '');
		const hasDevData = (get(projectDetails, 'type', '') === 'DEV' || get(projectDetails, 'associatedProject.type', '') === 'DEV');
		setDefaults(hasProdData, hasDevData);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [projectDetails]);

	return (
		<div>
			{show && <div>
				{isLoadingCarDetails &&
					<SdfBusyIndicator
						style={{ color: "#1a8099" }}
						size="xl"
						fullScreen={true}
					/>
				}
				{!isLoadingCarDetails && (isEndUserApp || isDataConnectorApp) ? <div>
					<div className="pt-10 p-1 text-heading-05 font-bold">
						<span>{`${selectedEnvironment.slice(0, 1)}${selectedEnvironment.slice(1, selectedEnvironment.length).toLocaleLowerCase()} scope`}</span>
					</div>
					{isDataConnectorApp &&
						<div>
							<ScopesConsentDetailSection
								detail={{
									title: ` Data Connector Scope (${b2bScopes.length})`,
									rows: b2bScopes.map((scope) => {
										return { text: scope }
									}),
									className:"break-all"
								}}
							/>
						</div>
					}
					{isEndUserApp && <div className="mt-5">
						<ScopesConsentDetailSection
							detail={{
								title: `End-user/SSO scope (${b2cScopes.length})`,
								rows: b2cScopes.map((scope) => {
									return { text: scope }
								}),
								className:"break-all"
							}}
						/>
					</div>}
					<div className="pt-10 p-1 text-heading-05 font-bold">
						<span>{`${selectedEnvironment.slice(0, 1)}${selectedEnvironment.slice(1, selectedEnvironment.length).toLocaleLowerCase()} authorization text`}</span>
					</div>
					{isDataConnectorApp &&
						<div>
							<ScopesConsentDetailSection
								detail={{
									title: `Data connector authorization text (${b2bConsents.length})`,
									rows: b2bConsents.map((scope) => {
										return { text: scope }
									}),
									className:"break-word"
								}}
							/>
						</div>}

					{isEndUserApp && <div className="mt-5">
						<ScopesConsentDetailSection
							detail={{
								title: `End-user/SSO authorization text (${b2cConsents.length})`,
								rows: b2cConsents.map((scope) => {
									return { text: scope }
								}),
								className:"break-word"
							}}
						/>
					</div>}
				</div> :
					!isLoadingCarDetails && <div className="flex justify-center"> No data </div>}
			</div >}
		</div>
	);
}

function ScopesConsentDetailSection({ detail }) {
	const title = get(detail, 'title', '');
	const rows = get(detail, 'rows', []);
	const className = get(detail, 'className', '');
	return (
		<div>
			<SdfExpandableBox
				variant="bordered"
				opened={true}
				triggerPlacement={"after"}
				header={title}
			>
				<div className="pt-10">
					{rows && rows.map((row, i) => <div className={`border-0 border-t-1 border-solid border-dark p-5 ${className}`} key={`${i}-row`}>
						{get(row, 'text', '')}
					</div>)}
				</div>
			</SdfExpandableBox>
		</div>
	);
}
